'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { LayoutProps } from '@/types/generalSettings';
import useSignalStore from '@/stores/layout/signalStore';

/** Alt text for the promo image (the panel gives no alt; an English slug was used before). */
const BANNER_ALT = 'پیشنهاد ویژه خانه سرمایه';

interface BannerSidebarProps {
    banners?: LayoutProps.Banners | undefined;
}

const BannerSidebar = ({ banners }: BannerSidebarProps) => {
    const { setIsOpen } = useSignalStore();
    return (
        <>
            {banners?.sheba?.show && banners?.sheba?.type === 'porsline' ? (
                <button
                    type='button'
                    onClick={() => setIsOpen(true)}
                    aria-haspopup='dialog'
                    className='shiningTopbar shine-card relative z-20 mt-5 block w-full cursor-pointer overflow-hidden rounded-xl'
                >
                    <Image
                        src={banners?.sheba?.image?.sourceUrl || '/landing-new-year/sheba.png'}
                        alt={BANNER_ALT}
                        width={1200}
                        height={1200}
                        // The sidebar is ~300px wide; without sizes a 1200-2048px file was fetched.
                        sizes='(min-width: 1024px) 360px, 100vw'
                        className='w-full object-cover'
                    />
                </button>
            ) : (
                <Link
                    prefetch={false}
                    target={'_blank'}
                    href={
                        banners?.sheba?.link?.url ||
                        'https://khanesarmaye.com/landing/earn-dollars/?utm_source=site&utm_medium=sidebar&utm_campaign=newyear'
                    }
                    rel='noopener'
                    className='shiningTopbar shine-card relative z-20 mx-auto block overflow-hidden rounded-lg'
                >
                    <Image
                        src={banners?.sheba?.image?.sourceUrl || '/landing-new-year/sheba.png'}
                        alt={BANNER_ALT}
                        width={1200}
                        height={1200}
                        // The sidebar is ~300px wide; without sizes a 1200-2048px file was fetched.
                        sizes='(min-width: 1024px) 360px, 100vw'
                        className='w-full object-cover'
                    />
                </Link>
            )}
        </>
    );
};

export default BannerSidebar;
